module.exports = __webpack_public_path__ + "img/tao.576523d4.png";